import axios from '../../../../utills/axiosConfig';

export const fetchRolePermissions = async (roleId) => {
  const res = await axios.get(`/role-permissions/${roleId}`);
  return res.data;
};

export const saveRolePermissions = async (roleId, permissions) => {
  const res = await axios.post('/role-permissions/save', { role_id: roleId, permissions });
  return res.data;
}; 